import Cookies from 'js-cookie';
import type { CookieAttributes } from 'js-cookie';

import { API } from '../../api';
import { getDomain } from './getDomain';

const prod = process.env.REACT_APP_ENV !== 'dev';
const domain = getDomain();
const params: CookieAttributes = {
  path: '/',
  secure: prod || false,
  sameSite: prod ? 'lax' : 'lax',
  domain: prod ? domain : '',
};

console.log('Initializing for: ', domain);

export const store = {
  getAuth: () => {
    const token = Cookies.get('access_token');
    API.TOKEN = token;

    return token;
  },
  setAuth: (token: string) => {
    API.TOKEN = token;
    return Cookies.set('access_token', token, { ...params, expires: 30 });
  },
  clearAuth: () => {
    API.TOKEN = '';
    return Cookies.remove('access_token', params);
  },
};
